<template>
	<v-app style="padding: 0px !important;">
		<v-container
      class="secondary"
			justify-ceneter
			align-center
			fluid
			fill-height
			style="padding: 0px !important;"
		>
			<!-- 登入視窗 -->
			<v-row
				align="center"
				justify="center"
				:style="{
					padding: '0px'
				}"
			>
				<v-col cols="12" sm="8" md="6" lg="4">
					<router-view></router-view>
				</v-col>
			</v-row>	
		</v-container>
	</v-app>
</template>
<script>

	export default {
		name: 'SignIn',
		components: {
		},
		created: function() {

		},
		mounted: function() {
			console.log(process.env.VUE_APP_MODE)
			console.log(process.env.VUE_APP_API_ENDPOINT)
		},
		data: function() {
			return {	
			}
		},
		methods: {
		}
	};
</script>
<style scoped>
	div.container{
		padding: 0 !important 
	}
	div.container--fluids {
		padding: 0 !important 
	}
</style>>